// import * as React from 'react';
// import { useTheme } from '@mui/material/styles';
// import useMediaQuery from '@mui/material/useMediaQuery';
// import Box from '@mui/material/Box';
// import List from '@mui/material/List';
// import CssBaseline from '@mui/material/CssBaseline';
// import Divider from '@mui/material/Divider';
// import IconButton from '@mui/material/IconButton';
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
// import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// import ListItem from '@mui/material/ListItem';
// import ListItemButton from '@mui/material/ListItemButton';
// import ListItemIcon from '@mui/material/ListItemIcon';
// import ListItemText from '@mui/material/ListItemText';
// import DashboardIcon from '@mui/icons-material/Dashboard';
// import OrderIcon from '@mui/icons-material/ShoppingCart';
// import LogoutIcon from '@mui/icons-material/Logout';
// import Tooltip from '@mui/material/Tooltip';
// import { Outlet, useNavigate, useLocation } from 'react-router-dom';
// import { ToastContainer } from 'react-toastify';
// import AddReactionIcon from '@mui/icons-material/AddReaction';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import ExpandLessIcon from '@mui/icons-material/ExpandLess';
// import { Drawer, DrawerHeader } from '../../components/component/ThemeComponent';
// import { getSingleProductServices } from '../../services/api/ProductAPI';

// interface Product {
// 	_id: string;
// 	productName: string;
// 	serviceName: string;
// 	// Add other properties as needed
// }

// const Products: string[] = ['Airtel', 'Jio', 'Vi', 'Tata'];

// const productIcons: Record<string, React.ReactNode> = {
// 	Airtel: <OrderIcon />, // Replace with the actual icon for Airtel
// 	Jio: <OrderIcon />, // Replace with the actual icon for Jio
// 	Vi: <OrderIcon />, // Replace with the actual icon for Vi
// 	Tata: <OrderIcon />, // Replace with the actual icon for TATA
// };

// export default function SideBar() {
// 	const theme = useTheme();
// 	const [open, setOpen] = React.useState(false);
// 	const [products, setProducts] = React.useState<Product[]>([]);
// 	const [dropdownOpen, setDropdownOpen] = React.useState<Record<string, boolean>>({});
// 	const navigate = useNavigate();
// 	const location = useLocation();
// 	const isXS = useMediaQuery(theme.breakpoints.only('xs'));
// 	const isSM = useMediaQuery(theme.breakpoints.only('sm'));
// 	const isMD = useMediaQuery(theme.breakpoints.only('md'));
// 	const isLG = useMediaQuery(theme.breakpoints.only('lg'));
// 	const isXL = useMediaQuery(theme.breakpoints.only('xl'));

// 	const handleDrawerOpen = () => {
// 		setOpen(true);
// 	};

// 	const handleDrawerClose = () => {
// 		setOpen(false);
// 	};

// 	const handleLogout = () => {
// 		localStorage.removeItem('refresh');
// 		localStorage.removeItem('token');
// 		navigate('/login');
// 	};

// 	const toggleDropdown = async (productName: string) => {
// 		setDropdownOpen((prevState) => ({
// 			...prevState,
// 			[productName]: !prevState[productName],
// 		}));

// 		if (!dropdownOpen[productName]) {
// 			const response = await getSingleProductServices(productName);
// 			setProducts(response.data);
// 		}
// 	};

// 	const navigateToProduct = (productName: string, productId: string) => {
// 		navigate(`/${productName.toLowerCase()}/${productId}`);
// 	};

// 	const navigateToProductList = (productName: string) => {
// 		navigate(`/${productName.toLowerCase()}`);
// 	};

// 	return (
// 		<Box sx={{ display: 'flex' }}>
// 			<CssBaseline />
// 			<Drawer variant="permanent" open={open}>
// 				<DrawerHeader
// 					sx={{
// 						justifyContent: 'space-between',
// 						alignItems: 'center',
// 						display: 'flex',
// 						flexDirection: 'row',
// 					}}
// 				>
// 					<Box
// 						sx={{
// 							display: open ? 'flex' : 'none',
// 							justifyContent: 'center',
// 							width: '100%',
// 						}}
// 					>
// 						<img
// 							src="assets/logo.png"
// 							width={175}
// 							loading="lazy"
// 							alt="yegova communicationLogo"
// 						/>
// 					</Box>
// 					<IconButton
// 						onClick={open ? handleDrawerClose : handleDrawerOpen}
// 						sx={{
// 							'&:hover': {
// 								backgroundColor: 'rgba(0, 0, 0, 0.1)',
// 								color: 'inherit',
// 							},
// 						}}
// 					>
// 						{open ? (
// 							theme.direction === 'rtl' ? (
// 								<ChevronRightIcon />
// 							) : (
// 								<ChevronLeftIcon />
// 							)
// 						) : theme.direction === 'rtl' ? (
// 							<ChevronLeftIcon />
// 						) : (
// 							<ChevronRightIcon />
// 						)}
// 					</IconButton>
// 				</DrawerHeader>
// 				<Divider />
// 				<List>
// 					{[
// 						{ text: 'Dashboard', icon: <DashboardIcon />, path: '/' },
// 						{ text: 'OTT Images', icon: <AddReactionIcon />, path: '/icon' },
// 					].map((item) => (
// 						<ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
// 							<Tooltip title={item.text} placement="right" arrow>
// 								<ListItemButton
// 									sx={[
// 										{
// 											minHeight: 48,
// 											px: 2.5,
// 											backgroundColor:
// 												location.pathname === item.path
// 													? '#EC008B'
// 													: 'inherit',
// 											color:
// 												location.pathname === item.path
// 													? 'white'
// 													: 'inherit',
// 											'&:hover': {
// 												color: '#fff',
// 												backgroundColor: '#EC008B',
// 												fill: '#fff',
// 											},
// 										},
// 										open
// 											? {
// 													justifyContent: 'initial',
// 												}
// 											: {
// 													justifyContent: 'center',
// 												},
// 									]}
// 									onClick={() => {
// 										navigate(item.path);
// 										handleDrawerClose();
// 									}}
// 								>
// 									<ListItemIcon
// 										sx={[
// 											{
// 												minWidth: 0,
// 												justifyContent: 'center',
// 												color:
// 													location.pathname === item.path
// 														? 'white'
// 														: 'inherit',
// 												'&:hover': {
// 													color: '#fff',
// 													fill: '#fff',
// 												},
// 											},
// 											open
// 												? {
// 														mr: 3,
// 													}
// 												: {
// 														mr: 'auto',
// 													},
// 										]}
// 									>
// 										{item.icon}
// 									</ListItemIcon>
// 									<ListItemText
// 										primary={item.text}
// 										sx={[
// 											open
// 												? {
// 														opacity: 1,
// 														color:
// 															location.pathname === item.path
// 																? 'white'
// 																: 'inherit',
// 													}
// 												: {
// 														opacity: 0,
// 													},
// 										]}
// 									/>
// 								</ListItemButton>
// 							</Tooltip>
// 						</ListItem>
// 					))}
// 					{Products.map((productName) => (
// 						<React.Fragment key={productName}>
// 							<ListItem disablePadding sx={{ display: 'block' }}>
// 								<ListItemButton
// 									onClick={() => navigateToProductList(productName)}
// 									sx={[
// 										{
// 											minHeight: 48,
// 											px: 2.5,
// 											backgroundColor: location.pathname.startsWith(
// 												`/${productName.toLowerCase()}`
// 											)
// 												? '#EC008B'
// 												: 'inherit',
// 											color: location.pathname.startsWith(
// 												`/${productName.toLowerCase()}`
// 											)
// 												? 'white'
// 												: 'inherit',
// 											'&:hover': {
// 												color: '#fff',
// 												backgroundColor: '#EC008B',
// 												fill: '#fff',
// 											},
// 										},
// 										open
// 											? {
// 													justifyContent: 'initial',
// 												}
// 											: {
// 													justifyContent: 'center',
// 												},
// 									]}
// 								>
// 									<ListItemIcon
// 										sx={[
// 											{
// 												minWidth: 0,
// 												justifyContent: 'center',
// 												color: location.pathname.startsWith(
// 													`/${productName.toLowerCase()}`
// 												)
// 													? 'white'
// 													: 'inherit',
// 												'&:hover': {
// 													color: '#fff',
// 													fill: '#fff',
// 												},
// 											},
// 											open
// 												? {
// 														mr: 3,
// 													}
// 												: {
// 														mr: 'auto',
// 													},
// 										]}
// 									>
// 										{productIcons[productName]}
// 									</ListItemIcon>
// 									<ListItemText
// 										primary={productName}
// 										sx={[
// 											open
// 												? {
// 														opacity: 1,
// 														color: location.pathname.startsWith(
// 															`/${productName.toLowerCase()}`
// 														)
// 															? 'white'
// 															: 'inherit',
// 													}
// 												: {
// 														opacity: 0,
// 													},
// 										]}
// 									/>
// 									{open && (
// 										<IconButton
// 											onClick={(e) => {
// 												e.stopPropagation();
// 												toggleDropdown(productName);
// 											}}
// 											sx={{
// 												color: location.pathname.startsWith(
// 													`/${productName.toLowerCase()}`
// 												)
// 													? 'white'
// 													: 'inherit',
// 												'&:hover': {
// 													color: '#fff',
// 												},
// 											}}
// 										>
// 											{dropdownOpen[productName] ? (
// 												<ExpandLessIcon />
// 											) : (
// 												<ExpandMoreIcon />
// 											)}
// 										</IconButton>
// 									)}
// 								</ListItemButton>
// 							</ListItem>
// 							{dropdownOpen[productName] && (
// 								<List
// 									component="div"
// 									disablePadding
// 									sx={{
// 										maxHeight: '300px', // Set the maximum height for the dropdown list
// 										overflowY: 'auto', // Add vertical scrollbar when content exceeds the maximum height
// 									}}
// 								>
// 									{products
// 										.filter((product) => product.productName === productName)
// 										.map((product) => (
// 											<ListItem
// 												key={product._id}
// 												disablePadding
// 												sx={{ display: 'block' }}
// 											>
// 												<ListItemButton
// 													sx={[
// 														{
// 															minHeight: 48,
// 															px: 2.5,
// 															pl: 4,
// 															backgroundColor:
// 																location.pathname ===
// 																`/${productName.toLowerCase()}/${product._id}`
// 																	? '#EC008B'
// 																	: 'inherit',
// 															color:
// 																location.pathname ===
// 																`/${productName.toLowerCase()}/${product._id}`
// 																	? 'white'
// 																	: 'inherit',
// 															'&:hover': {
// 																color: '#fff',
// 																backgroundColor: '#EC008B',
// 																fill: '#fff',
// 															},
// 														},
// 														open
// 															? {
// 																	justifyContent: 'initial',
// 																}
// 															: {
// 																	justifyContent: 'center',
// 																},
// 													]}
// 													onClick={() =>
// 														navigateToProduct(productName, product._id)
// 													}
// 												>
// 													<ListItemText
// 														primary={product.serviceName}
// 														sx={[
// 															open
// 																? {
// 																		opacity: 1,
// 																		color:
// 																			location.pathname ===
// 																			`/product/${product._id}`
// 																				? 'white'
// 																				: 'inherit',
// 																	}
// 																: {
// 																		opacity: 0,
// 																	},
// 														]}
// 													/>
// 												</ListItemButton>
// 											</ListItem>
// 										))}
// 								</List>
// 							)}
// 						</React.Fragment>
// 					))}
// 				</List>
// 				<Divider />
// 				<List sx={{ marginTop: 'auto' }}>
// 					<ListItem disablePadding sx={{ display: 'block' }}>
// 						<ListItemButton
// 							onClick={handleLogout}
// 							sx={[
// 								{
// 									minHeight: 48,
// 									px: 2.5,
// 									color: '#000',
// 									'&:hover': {
// 										color: '#fff',
// 										backgroundColor: '#EC008B',
// 										fill: '#fff',
// 									},
// 								},
// 								open
// 									? {
// 											justifyContent: 'initial',
// 										}
// 									: {
// 											justifyContent: 'center',
// 										},
// 							]}
// 						>
// 							<ListItemIcon
// 								sx={[
// 									{
// 										minWidth: 0,
// 										justifyContent: 'center',
// 										color: 'inherit',
// 									},
// 									open
// 										? {
// 												mr: 3,
// 											}
// 										: {
// 												mr: 'auto',
// 											},
// 								]}
// 							>
// 								<Tooltip title="Logout" placement="right">
// 									<LogoutIcon />
// 								</Tooltip>
// 							</ListItemIcon>
// 							<ListItemText
// 								primary="Logout"
// 								sx={[
// 									open
// 										? {
// 												opacity: 1,
// 											}
// 										: {
// 												opacity: 0,
// 											},
// 								]}
// 							/>
// 						</ListItemButton>
// 					</ListItem>
// 				</List>
// 			</Drawer>
// 			<Box
// 				component="main"
// 				sx={{
// 					flexGrow: 1,
// 					p: isXS ? 1 : isSM ? 2 : isMD ? 3 : isLG ? 4 : 5,
// 					width: isXS
// 						? 'calc(100% - 65px)'
// 						: isSM
// 							? 'calc(100% - 65px)'
// 							: isMD
// 								? 'calc(100% - 65px)'
// 								: isLG
// 									? 'calc(100% - 65px)'
// 									: isXL
// 										? 'calc(100% - 65px)'
// 										: 'auto',
// 				}}
// 			>
// 				<div>
// 					<ToastContainer position="top-right" autoClose={3000} />
// 					<Outlet />
// 				</div>
// 			</Box>
// 		</Box>
// 	);
// }
// ===========================================================================================================
// ===========================================================================================================
// ===========================================================================================================
// ===========================================================================================================
// ===========================================================================================================
// ===========================================================================================================
// ===========================================================================================================
// ===========================================================================================================
// ===========================================================================================================
// ===========================================================================================================
// ===========================================================================================================
// ===========================================================================================================
// ===========================================================================================================
// import * as React from 'react';
// import { useTheme } from '@mui/material/styles';
// import useMediaQuery from '@mui/material/useMediaQuery';
// import Box from '@mui/material/Box';
// import List from '@mui/material/List';
// import CssBaseline from '@mui/material/CssBaseline';
// import Divider from '@mui/material/Divider';
// import IconButton from '@mui/material/IconButton';
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
// import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// import ListItem from '@mui/material/ListItem';
// import ListItemButton from '@mui/material/ListItemButton';
// import ListItemIcon from '@mui/material/ListItemIcon';
// import ListItemText from '@mui/material/ListItemText';
// import DashboardIcon from '@mui/icons-material/Dashboard';
// import OrderIcon from '@mui/icons-material/ShoppingCart';
// import LogoutIcon from '@mui/icons-material/Logout';
// import Tooltip from '@mui/material/Tooltip';
// import { Outlet, useNavigate, useLocation } from 'react-router-dom';
// import { ToastContainer } from 'react-toastify';
// import AddReactionIcon from '@mui/icons-material/AddReaction';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import ExpandLessIcon from '@mui/icons-material/ExpandLess';
// import { Drawer, DrawerHeader } from '../../components/component/ThemeComponent';
// import { getSingleProductServices } from '../../services/api/ProductAPI';

// interface Product {
// 	_id: string;
// 	productName: string;
// 	serviceName: string;
// 	// Add other properties as needed
// }

// const Products: string[] = ['Airtel', 'Jio', 'Vi', 'Tata'];

// const productIcons: Record<string, React.ReactNode> = {
// 	Airtel: <OrderIcon />, // Replace with the actual icon for Airtel
// 	Jio: <OrderIcon />, // Replace with the actual icon for Jio
// 	Vi: <OrderIcon />, // Replace with the actual icon for Vi
// 	Tata: <OrderIcon />, // Replace with the actual icon for TATA
// };

// export default function SideBar() {
// 	const theme = useTheme();
// 	const [open, setOpen] = React.useState(false);
// 	const [products, setProducts] = React.useState<Product[]>([]);
// 	const [dropdownOpen, setDropdownOpen] = React.useState<Record<string, boolean>>({});
// 	const navigate = useNavigate();
// 	const location = useLocation();
// 	const isXS = useMediaQuery(theme.breakpoints.only('xs'));
// 	const isSM = useMediaQuery(theme.breakpoints.only('sm'));
// 	const isMD = useMediaQuery(theme.breakpoints.only('md'));
// 	const isLG = useMediaQuery(theme.breakpoints.only('lg'));
// 	const isXL = useMediaQuery(theme.breakpoints.only('xl'));

// 	const handleDrawerOpen = () => {
// 		setOpen(true);
// 	};

// 	const handleDrawerClose = () => {
// 		setOpen(false);
// 	};

// 	const handleLogout = () => {
// 		localStorage.removeItem('refresh');
// 		localStorage.removeItem('token');
// 		navigate('/login');
// 	};

// 	const toggleDropdown = async (productName: string) => {
// 		setDropdownOpen((prevState) => ({
// 			...prevState,
// 			[productName]: !prevState[productName],
// 		}));

// 		if (!dropdownOpen[productName]) {
// 			const response = await getSingleProductServices(productName);
// 			setProducts(response.data);
// 		}
// 	};

// 	const navigateToProduct = (productName: string, productId: string) => {
// 		navigate(`/${productName.toLowerCase()}/${productId}`);
// 		handleDrawerClose(); // Close the sidebar after navigation
// 		setDropdownOpen((prevState) => ({
// 			...prevState,
// 			[productName]: false, // Close the dropdown for the selected product
// 		}));
// 	};

// 	const navigateToProductList = (productName: string) => {
// 		navigate(`/${productName.toLowerCase()}`);
// 	};

// 	return (
// 		<Box sx={{ display: 'flex' }}>
// 			<CssBaseline />
// 			<Drawer variant="permanent" open={open}>
// 				<DrawerHeader
// 					sx={{
// 						justifyContent: 'space-between',
// 						alignItems: 'center',
// 						display: 'flex',
// 						flexDirection: 'row',
// 					}}
// 				>
// 					<Box
// 						sx={{
// 							display: open ? 'flex' : 'none',
// 							justifyContent: 'center',
// 							width: '100%',
// 						}}
// 					>
// 						<img
// 							src="/assets/logo.png"
// 							width={175}
// 							loading="lazy"
// 							alt="yegova TelecommunicationLogo"
// 						/>
// 					</Box>
// 					<IconButton
// 						onClick={open ? handleDrawerClose : handleDrawerOpen}
// 						sx={{
// 							'&:hover': {
// 								backgroundColor: 'rgba(0, 0, 0, 0.1)',
// 								color: 'inherit',
// 							},
// 						}}
// 					>
// 						{open ? (
// 							theme.direction === 'rtl' ? (
// 								<ChevronRightIcon />
// 							) : (
// 								<ChevronLeftIcon />
// 							)
// 						) : theme.direction === 'rtl' ? (
// 							<ChevronLeftIcon />
// 						) : (
// 							<ChevronRightIcon />
// 						)}
// 					</IconButton>
// 				</DrawerHeader>
// 				<Divider />
// 				<List>
// 					{[
// 						{ text: 'Dashboard', icon: <DashboardIcon />, path: '/' },
// 						{ text: 'OTT Images', icon: <AddReactionIcon />, path: '/icon' },
// 					].map((item) => (
// 						<ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
// 							<Tooltip title={item.text} placement="right" arrow>
// 								<ListItemButton
// 									sx={[
// 										{
// 											minHeight: 48,
// 											px: 2.5,
// 											backgroundColor:
// 												location.pathname === item.path
// 													? '#EC008B'
// 													: 'inherit',
// 											color:
// 												location.pathname === item.path
// 													? 'white'
// 													: 'inherit',
// 											'&:hover': {
// 												color: '#fff',
// 												backgroundColor: '#EC008B',
// 												fill: '#fff',
// 											},
// 										},
// 										open
// 											? {
// 													justifyContent: 'initial',
// 												}
// 											: {
// 													justifyContent: 'center',
// 												},
// 									]}
// 									onClick={() => {
// 										navigate(item.path);
// 										handleDrawerClose();
// 									}}
// 								>
// 									<ListItemIcon
// 										sx={[
// 											{
// 												minWidth: 0,
// 												justifyContent: 'center',
// 												color:
// 													location.pathname === item.path
// 														? 'white'
// 														: 'inherit',
// 												'&:hover': {
// 													color: '#fff',
// 													fill: '#fff',
// 												},
// 											},
// 											open
// 												? {
// 														mr: 3,
// 													}
// 												: {
// 														mr: 'auto',
// 													},
// 										]}
// 									>
// 										{item.icon}
// 									</ListItemIcon>
// 									<ListItemText
// 										primary={item.text}
// 										sx={[
// 											open
// 												? {
// 														opacity: 1,
// 														color:
// 															location.pathname === item.path
// 																? 'white'
// 																: 'inherit',
// 													}
// 												: {
// 														opacity: 0,
// 													},
// 										]}
// 									/>
// 								</ListItemButton>
// 							</Tooltip>
// 						</ListItem>
// 					))}
// 					{Products.map((productName) => (
// 						<React.Fragment key={productName}>
// 							<ListItem disablePadding sx={{ display: 'block' }}>
// 								<ListItemButton
// 									onClick={() => navigateToProductList(productName)}
// 									sx={[
// 										{
// 											minHeight: 48,
// 											px: 2.5,
// 											backgroundColor: location.pathname.startsWith(
// 												`/${productName.toLowerCase()}`
// 											)
// 												? '#EC008B'
// 												: 'inherit',
// 											color: location.pathname.startsWith(
// 												`/${productName.toLowerCase()}`
// 											)
// 												? 'white'
// 												: 'inherit',
// 											'&:hover': {
// 												color: '#fff',
// 												backgroundColor: '#EC008B',
// 												fill: '#fff',
// 											},
// 										},
// 										open
// 											? {
// 													justifyContent: 'initial',
// 												}
// 											: {
// 													justifyContent: 'center',
// 												},
// 									]}
// 								>
// 									<ListItemIcon
// 										sx={[
// 											{
// 												minWidth: 0,
// 												justifyContent: 'center',
// 												color: location.pathname.startsWith(
// 													`/${productName.toLowerCase()}`
// 												)
// 													? 'white'
// 													: 'inherit',
// 												'&:hover': {
// 													color: '#fff',
// 													fill: '#fff',
// 												},
// 											},
// 											open
// 												? {
// 														mr: 3,
// 													}
// 												: {
// 														mr: 'auto',
// 													},
// 										]}
// 									>
// 										{productIcons[productName]}
// 									</ListItemIcon>
// 									<ListItemText
// 										primary={productName}
// 										sx={[
// 											open
// 												? {
// 														opacity: 1,
// 														color: location.pathname.startsWith(
// 															`/${productName.toLowerCase()}`
// 														)
// 															? 'white'
// 															: 'inherit',
// 													}
// 												: {
// 														opacity: 0,
// 													},
// 										]}
// 									/>
// 									{open && (
// 										<IconButton
// 											onClick={(e) => {
// 												e.stopPropagation();
// 												toggleDropdown(productName);
// 											}}
// 											sx={{
// 												color: location.pathname.startsWith(
// 													`/${productName.toLowerCase()}`
// 												)
// 													? 'white'
// 													: 'inherit',
// 												'&:hover': {
// 													color: '#fff',
// 												},
// 											}}
// 										>
// 											{dropdownOpen[productName] ? (
// 												<ExpandLessIcon />
// 											) : (
// 												<ExpandMoreIcon />
// 											)}
// 										</IconButton>
// 									)}
// 								</ListItemButton>
// 							</ListItem>
// 							{dropdownOpen[productName] && (
// 								<List
// 									component="div"
// 									disablePadding
// 									sx={{
// 										maxHeight: '300px', // Set the maximum height for the dropdown list
// 										overflowY: 'auto', // Add vertical scrollbar when content exceeds the maximum height
// 									}}
// 								>
// 									{products
// 										.filter((product) => product.productName === productName)
// 										.map((product) => (
// 											<ListItem
// 												key={product._id}
// 												disablePadding
// 												sx={{ display: 'block' }}
// 											>
// 												<ListItemButton
// 													sx={[
// 														{
// 															minHeight: 48,
// 															px: 2.5,
// 															pl: 4,
// 															backgroundColor:
// 																location.pathname ===
// 																`/${productName.toLowerCase()}/${product._id}`
// 																	? '#EC008B'
// 																	: 'inherit',
// 															color:
// 																location.pathname ===
// 																`/${productName.toLowerCase()}/${product._id}`
// 																	? 'white'
// 																	: 'inherit',
// 															'&:hover': {
// 																color: '#fff',
// 																backgroundColor: '#EC008B',
// 																fill: '#fff',
// 															},
// 														},
// 														open
// 															? {
// 																	justifyContent: 'initial',
// 																}
// 															: {
// 																	justifyContent: 'center',
// 																},
// 													]}
// 													onClick={() =>
// 														navigateToProduct(productName, product._id)
// 													}
// 												>
// 													<ListItemText
// 														primary={product.serviceName}
// 														sx={[
// 															open
// 																? {
// 																		opacity: 1,
// 																		color:
// 																			location.pathname ===
// 																			`/product/${product._id}`
// 																				? 'white'
// 																				: 'inherit',
// 																	}
// 																: {
// 																		opacity: 0,
// 																	},
// 														]}
// 													/>
// 												</ListItemButton>
// 											</ListItem>
// 										))}
// 								</List>
// 							)}
// 						</React.Fragment>
// 					))}
// 				</List>
// 				<Divider />
// 				<List sx={{ marginTop: 'auto' }}>
// 					<ListItem disablePadding sx={{ display: 'block' }}>
// 						<ListItemButton
// 							onClick={handleLogout}
// 							sx={[
// 								{
// 									minHeight: 48,
// 									px: 2.5,
// 									color: '#000',
// 									'&:hover': {
// 										color: '#fff',
// 										backgroundColor: '#EC008B',
// 										fill: '#fff',
// 									},
// 								},
// 								open
// 									? {
// 											justifyContent: 'initial',
// 										}
// 									: {
// 											justifyContent: 'center',
// 										},
// 							]}
// 						>
// 							<ListItemIcon
// 								sx={[
// 									{
// 										minWidth: 0,
// 										justifyContent: 'center',
// 										color: 'inherit',
// 									},
// 									open
// 										? {
// 												mr: 3,
// 											}
// 										: {
// 												mr: 'auto',
// 											},
// 								]}
// 							>
// 								<Tooltip title="Logout" placement="right">
// 									<LogoutIcon />
// 								</Tooltip>
// 							</ListItemIcon>
// 							<ListItemText
// 								primary="Logout"
// 								sx={[
// 									open
// 										? {
// 												opacity: 1,
// 											}
// 										: {
// 												opacity: 0,
// 											},
// 								]}
// 							/>
// 						</ListItemButton>
// 					</ListItem>
// 				</List>
// 			</Drawer>
// 			<Box
// 				component="main"
// 				sx={{
// 					flexGrow: 1,
// 					p: isXS ? 1 : isSM ? 2 : isMD ? 3 : isLG ? 4 : 5,
// 					width: isXS
// 						? 'calc(100% - 65px)'
// 						: isSM
// 							? 'calc(100% - 65px)'
// 							: isMD
// 								? 'calc(100% - 65px)'
// 								: isLG
// 									? 'calc(100% - 65px)'
// 									: isXL
// 										? 'calc(100% - 65px)'
// 										: 'auto',
// 				}}
// 			>
// 				<div>
// 					<ToastContainer position="top-right" autoClose={3000} />
// 					<Outlet />
// 				</div>
// 			</Box>
// 		</Box>
// 	);
// }
// =================================================================================================================
// =================================================================================================================
// =================================================================================================================
// =================================================================================================================
// =================================================================================================================
// =================================================================================================================
// =================================================================================================================
// =================================================================================================================
// =================================================================================================================
// =================================================================================================================
// =================================================================================================================
// =================================================================================================================
// =================================================================================================================
// =================================================================================================================

// import * as React from 'react';
// import { useTheme } from '@mui/material/styles';
// import useMediaQuery from '@mui/material/useMediaQuery';
// import Box from '@mui/material/Box';
// import List from '@mui/material/List';
// import CssBaseline from '@mui/material/CssBaseline';
// import Divider from '@mui/material/Divider';
// import IconButton from '@mui/material/IconButton';
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
// import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// import ListItem from '@mui/material/ListItem';
// import ListItemButton from '@mui/material/ListItemButton';
// import ListItemIcon from '@mui/material/ListItemIcon';
// import ListItemText from '@mui/material/ListItemText';
// import DashboardIcon from '@mui/icons-material/Dashboard';
// import OrderIcon from '@mui/icons-material/ShoppingCart';
// import LogoutIcon from '@mui/icons-material/Logout';
// import Tooltip from '@mui/material/Tooltip';
// import { Outlet, useNavigate, useLocation } from 'react-router-dom';
// import { ToastContainer } from 'react-toastify';
// import AddReactionIcon from '@mui/icons-material/AddReaction';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import ExpandLessIcon from '@mui/icons-material/ExpandLess';
// import { Drawer, DrawerHeader } from '../../components/component/ThemeComponent';
// import { getSingleProductServices } from '../../services/api/ProductAPI';

// interface Product {
// 	_id: string;
// 	productName: string;
// 	serviceName: string;
// 	// Add other properties as needed
// }

// const Products: string[] = ['Airtel', 'Jio', 'Vi', 'Tata'];

// const productIcons: Record<string, React.ReactNode> = {
// 	Airtel: (
// 		<img
// 			src="/assets/airtel-logo.svg"
// 			alt="Airtel"
// 			style={{ width: 30, height: 30, backgroundColor: '#fff', borderRadius: '49px' }}
// 		/>
// 	), // Replace with the actual image path for Airtel
// 	Jio: <img src="/assets/jio-logo.png" alt="Jio" style={{ width: 24, height: 24 }} />, // Replace with the actual image path for Jio
// 	Vi: <img src="/assets/vi-logo.png" alt="Vi" style={{ width: 24, height: 24 }} />, // Replace with the actual image path for Vi
// 	Tata: <img src="/assets/tata-logo.png" alt="Tata" style={{ width: 24, height: 24 }} />, // Replace with the actual image path for TATA
// };

// export default function SideBar() {
// 	const theme = useTheme();
// 	const [open, setOpen] = React.useState(false);
// 	const [products, setProducts] = React.useState<Product[]>([]);
// 	const [dropdownOpen, setDropdownOpen] = React.useState<Record<string, boolean>>({});
// 	const navigate = useNavigate();
// 	const location = useLocation();
// 	const isXS = useMediaQuery(theme.breakpoints.only('xs'));
// 	const isSM = useMediaQuery(theme.breakpoints.only('sm'));
// 	const isMD = useMediaQuery(theme.breakpoints.only('md'));
// 	const isLG = useMediaQuery(theme.breakpoints.only('lg'));
// 	const isXL = useMediaQuery(theme.breakpoints.only('xl'));

// 	const handleDrawerOpen = () => {
// 		setOpen(true);
// 	};

// 	const handleDrawerClose = () => {
// 		setOpen(false);
// 	};

// 	const handleLogout = () => {
// 		localStorage.removeItem('refresh');
// 		localStorage.removeItem('token');
// 		navigate('/login');
// 	};

// 	const toggleDropdown = async (productName: string) => {
// 		setDropdownOpen((prevState) => ({
// 			...prevState,
// 			[productName]: !prevState[productName],
// 		}));

// 		if (!dropdownOpen[productName]) {
// 			const response = await getSingleProductServices(productName);
// 			setProducts(response.data);
// 		}
// 	};

// 	const navigateToProduct = (productName: string, productId: string) => {
// 		navigate(`/${productName.toLowerCase()}/${productId}`);
// 		handleDrawerClose(); // Close the sidebar after navigation
// 		setDropdownOpen((prevState) => ({
// 			...prevState,
// 			[productName]: false, // Close the dropdown for the selected product
// 		}));
// 	};

// 	const navigateToProductList = (productName: string) => {
// 		navigate(`/${productName.toLowerCase()}`);
// 	};

// 	return (
// 		<Box sx={{ display: 'flex' }}>
// 			<CssBaseline />
// 			<Drawer variant="permanent" open={open}>
// 				<DrawerHeader
// 					sx={{
// 						justifyContent: 'space-between',
// 						alignItems: 'center',
// 						display: 'flex',
// 						flexDirection: 'row',
// 					}}
// 				>
// 					<Box
// 						sx={{
// 							display: open ? 'flex' : 'none',
// 							justifyContent: 'center',
// 							width: '100%',
// 						}}
// 					>
// 						<img
// 							src="/assets/logo.png"
// 							width={175}
// 							loading="lazy"
// 							alt="yegova TelecommunicationLogo"
// 						/>
// 					</Box>
// 					<IconButton
// 						onClick={open ? handleDrawerClose : handleDrawerOpen}
// 						sx={{
// 							'&:hover': {
// 								backgroundColor: 'rgba(0, 0, 0, 0.1)',
// 								color: 'inherit',
// 							},
// 						}}
// 					>
// 						{open ? (
// 							theme.direction === 'rtl' ? (
// 								<ChevronRightIcon />
// 							) : (
// 								<ChevronLeftIcon />
// 							)
// 						) : theme.direction === 'rtl' ? (
// 							<ChevronLeftIcon />
// 						) : (
// 							<ChevronRightIcon />
// 						)}
// 					</IconButton>
// 				</DrawerHeader>
// 				<Divider />
// 				<List>
// 					{[
// 						{ text: 'Dashboard', icon: <DashboardIcon />, path: '/' },
// 						{ text: 'OTT Images', icon: <AddReactionIcon />, path: '/icon' },
// 					].map((item) => (
// 						<ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
// 							<Tooltip title={item.text} placement="right" arrow>
// 								<ListItemButton
// 									sx={[
// 										{
// 											minHeight: 48,
// 											px: 2.5,
// 											backgroundColor:
// 												location.pathname === item.path
// 													? '#EC008B'
// 													: 'inherit',
// 											color:
// 												location.pathname === item.path
// 													? 'white'
// 													: 'inherit',
// 											'&:hover': {
// 												color: '#fff',
// 												backgroundColor: '#EC008B',
// 												fill: '#fff',
// 											},
// 										},
// 										open
// 											? {
// 													justifyContent: 'initial',
// 												}
// 											: {
// 													justifyContent: 'center',
// 												},
// 									]}
// 									onClick={() => {
// 										navigate(item.path);
// 										handleDrawerClose();
// 									}}
// 								>
// 									<ListItemIcon
// 										sx={[
// 											{
// 												minWidth: 0,
// 												justifyContent: 'center',
// 												color:
// 													location.pathname === item.path
// 														? 'white'
// 														: 'inherit',
// 												'&:hover': {
// 													color: '#fff',
// 													fill: '#fff',
// 												},
// 											},
// 											open
// 												? {
// 														mr: 3,
// 													}
// 												: {
// 														mr: 'auto',
// 													},
// 										]}
// 									>
// 										{item.icon}
// 									</ListItemIcon>
// 									<ListItemText
// 										primary={item.text}
// 										sx={[
// 											open
// 												? {
// 														opacity: 1,
// 														color:
// 															location.pathname === item.path
// 																? 'white'
// 																: 'inherit',
// 													}
// 												: {
// 														opacity: 0,
// 													},
// 										]}
// 									/>
// 								</ListItemButton>
// 							</Tooltip>
// 						</ListItem>
// 					))}
// 					{Products.map((productName) => (
// 						<React.Fragment key={productName}>
// 							<ListItem disablePadding sx={{ display: 'block' }}>
// 								<ListItemButton
// 									onClick={() => navigateToProductList(productName)}
// 									sx={[
// 										{
// 											minHeight: 48,
// 											px: 2.5,
// 											backgroundColor: location.pathname.startsWith(
// 												`/${productName.toLowerCase()}`
// 											)
// 												? '#EC008B'
// 												: 'inherit',
// 											color: location.pathname.startsWith(
// 												`/${productName.toLowerCase()}`
// 											)
// 												? 'white'
// 												: 'inherit',
// 											'&:hover': {
// 												color: '#fff',
// 												backgroundColor: '#EC008B',
// 												fill: '#fff',
// 											},
// 										},
// 										open
// 											? {
// 													justifyContent: 'initial',
// 												}
// 											: {
// 													justifyContent: 'center',
// 												},
// 									]}
// 								>
// 									<ListItemIcon
// 										sx={[
// 											{
// 												minWidth: 0,
// 												justifyContent: 'center',
// 												color: location.pathname.startsWith(
// 													`/${productName.toLowerCase()}`
// 												)
// 													? 'white'
// 													: 'inherit',
// 												'&:hover': {
// 													color: '#fff',
// 													fill: '#fff',
// 												},
// 											},
// 											open
// 												? {
// 														mr: 3,
// 													}
// 												: {
// 														mr: 'auto',
// 													},
// 										]}
// 									>
// 										{productIcons[productName]}
// 									</ListItemIcon>
// 									<ListItemText
// 										primary={productName}
// 										sx={[
// 											open
// 												? {
// 														opacity: 1,
// 														color: location.pathname.startsWith(
// 															`/${productName.toLowerCase()}`
// 														)
// 															? 'white'
// 															: 'inherit',
// 													}
// 												: {
// 														opacity: 0,
// 													},
// 										]}
// 									/>
// 									{open && (
// 										<IconButton
// 											onClick={(e) => {
// 												e.stopPropagation();
// 												toggleDropdown(productName);
// 											}}
// 											sx={{
// 												color: location.pathname.startsWith(
// 													`/${productName.toLowerCase()}`
// 												)
// 													? 'white'
// 													: 'inherit',
// 												'&:hover': {
// 													color: '#fff',
// 												},
// 											}}
// 										>
// 											{dropdownOpen[productName] ? (
// 												<ExpandLessIcon />
// 											) : (
// 												<ExpandMoreIcon />
// 											)}
// 										</IconButton>
// 									)}
// 								</ListItemButton>
// 							</ListItem>
// 							{dropdownOpen[productName] && (
// 								<List
// 									component="div"
// 									disablePadding
// 									sx={{
// 										maxHeight: '300px', // Set the maximum height for the dropdown list
// 										overflowY: 'auto', // Add vertical scrollbar when content exceeds the maximum height
// 									}}
// 								>
// 									{products
// 										.filter((product) => product.productName === productName)
// 										.map((product) => (
// 											<ListItem
// 												key={product._id}
// 												disablePadding
// 												sx={{ display: 'block' }}
// 											>
// 												<ListItemButton
// 													sx={[
// 														{
// 															minHeight: 48,
// 															px: 2.5,
// 															pl: 4,
// 															backgroundColor:
// 																location.pathname ===
// 																`/${productName.toLowerCase()}/${product._id}`
// 																	? '#EC008B'
// 																	: 'inherit',
// 															color:
// 																location.pathname ===
// 																`/${productName.toLowerCase()}/${product._id}`
// 																	? 'white'
// 																	: 'inherit',
// 															'&:hover': {
// 																color: '#fff',
// 																backgroundColor: '#EC008B',
// 																fill: '#fff',
// 															},
// 														},
// 														open
// 															? {
// 																	justifyContent: 'initial',
// 																}
// 															: {
// 																	justifyContent: 'center',
// 																},
// 													]}
// 													onClick={() =>
// 														navigateToProduct(productName, product._id)
// 													}
// 												>
// 													<ListItemText
// 														primary={product.serviceName}
// 														sx={[
// 															open
// 																? {
// 																		opacity: 1,
// 																		color:
// 																			location.pathname ===
// 																			`/product/${product._id}`
// 																				? 'white'
// 																				: 'inherit',
// 																	}
// 																: {
// 																		opacity: 0,
// 																	},
// 														]}
// 													/>
// 												</ListItemButton>
// 											</ListItem>
// 										))}
// 								</List>
// 							)}
// 						</React.Fragment>
// 					))}
// 				</List>
// 				<Divider />
// 				<List sx={{ marginTop: 'auto' }}>
// 					<ListItem disablePadding sx={{ display: 'block' }}>
// 						<ListItemButton
// 							onClick={handleLogout}
// 							sx={[
// 								{
// 									minHeight: 48,
// 									px: 2.5,
// 									color: '#000',
// 									'&:hover': {
// 										color: '#fff',
// 										backgroundColor: '#EC008B',
// 										fill: '#fff',
// 									},
// 								},
// 								open
// 									? {
// 											justifyContent: 'initial',
// 										}
// 									: {
// 											justifyContent: 'center',
// 										},
// 							]}
// 						>
// 							<ListItemIcon
// 								sx={[
// 									{
// 										minWidth: 0,
// 										justifyContent: 'center',
// 										color: 'inherit',
// 									},
// 									open
// 										? {
// 												mr: 3,
// 											}
// 										: {
// 												mr: 'auto',
// 											},
// 								]}
// 							>
// 								<Tooltip title="Logout" placement="right">
// 									<LogoutIcon />
// 								</Tooltip>
// 							</ListItemIcon>
// 							<ListItemText
// 								primary="Logout"
// 								sx={[
// 									open
// 										? {
// 												opacity: 1,
// 											}
// 										: {
// 												opacity: 0,
// 											},
// 								]}
// 							/>
// 						</ListItemButton>
// 					</ListItem>
// 				</List>
// 			</Drawer>
// 			<Box
// 				component="main"
// 				sx={{
// 					flexGrow: 1,
// 					p: isXS ? 1 : isSM ? 2 : isMD ? 3 : isLG ? 4 : 5,
// 					width: isXS
// 						? 'calc(100% - 65px)'
// 						: isSM
// 							? 'calc(100% - 65px)'
// 							: isMD
// 								? 'calc(100% - 65px)'
// 								: isLG
// 									? 'calc(100% - 65px)'
// 									: isXL
// 										? 'calc(100% - 65px)'
// 										: 'auto',
// 				}}
// 			>
// 				<div>
// 					<ToastContainer position="top-right" autoClose={3000} />
// 					<Outlet />
// 				</div>
// 			</Box>
// 		</Box>
// 	);
// }
// =================================================================================
// =================================================================================
// =================================================================================
// =================================================================================
// =================================================================================
// =================================================================================
// =================================================================================
// =================================================================================
// =================================================================================
// =================================================================================
// =================================================================================
// =================================================================================

import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DashboardIcon from '@mui/icons-material/Dashboard';
// import OrderIcon from '@mui/icons-material/ShoppingCart';
import LogoutIcon from '@mui/icons-material/Logout';
import Tooltip from '@mui/material/Tooltip';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import AddReactionIcon from '@mui/icons-material/AddReaction';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { Drawer, DrawerHeader } from '../../components/component/ThemeComponent';
import { getSingleProductServices } from '../../services/api/ProductAPI';

interface Product {
	_id: string;
	productName: string;
	serviceName: string;
	// Add other properties as needed
}

const Products: string[] = ['Airtel', 'Jio', 'Vi', 'Tata'];

const productIcons: Record<string, React.ReactNode> = {
	Airtel: <img src="/assets/airtel-logo.svg" alt="Airtel" style={{ width: 30, height: 30 }} />, // Replace with the actual image path for Airtel
	Jio: <img src="/assets/jio-logo.png" alt="Jio" style={{ width: 30, height: 30 }} />, // Replace with the actual image path for Jio
	Vi: <img src="/assets/vi-logo.png" alt="Vi" style={{ width: 30, height: 30 }} />, // Replace with the actual image path for Vi
	Tata: <img src="/assets/tata-logo.png" alt="Tata" style={{ width: 30, height: 30 }} />, // Replace with the actual image path for TATA
};

export default function SideBar() {
	const theme = useTheme();
	const [open, setOpen] = React.useState(false);
	const [products, setProducts] = React.useState<Product[]>([]);
	const [dropdownOpen, setDropdownOpen] = React.useState<Record<string, boolean>>({});
	const navigate = useNavigate();
	const location = useLocation();
	const isXS = useMediaQuery(theme.breakpoints.only('xs'));
	const isSM = useMediaQuery(theme.breakpoints.only('sm'));
	const isMD = useMediaQuery(theme.breakpoints.only('md'));
	const isLG = useMediaQuery(theme.breakpoints.only('lg'));
	const isXL = useMediaQuery(theme.breakpoints.only('xl'));

	const handleDrawerOpen = () => {
		setOpen(true);
	};

	const handleDrawerClose = () => {
		setOpen(false);
	};

	const handleLogout = () => {
		localStorage.removeItem('refresh');
		localStorage.removeItem('token');
		navigate('/login');
	};

	const toggleDropdown = async (productName: string) => {
		setDropdownOpen((prevState) => ({
			...prevState,
			[productName]: !prevState[productName],
		}));

		if (!dropdownOpen[productName]) {
			const response = await getSingleProductServices(productName);
			setProducts(response.data);
		}
	};

	const navigateToProduct = (productName: string, productId: string) => {
		navigate(`/${productName.toLowerCase()}/${productId}`);
		handleDrawerClose(); // Close the sidebar after navigation
		setDropdownOpen((prevState) => ({
			...prevState,
			[productName]: false, // Close the dropdown for the selected product
		}));
	};

	const navigateToProductList = (productName: string) => {
		navigate(`/${productName.toLowerCase()}`);
	};

	return (
		<Box sx={{ display: 'flex' }}>
			<CssBaseline />
			<Drawer variant="permanent" open={open}>
				<DrawerHeader
					sx={{
						justifyContent: 'space-between',
						alignItems: 'center',
						display: 'flex',
						flexDirection: 'row',
					}}
				>
					<Box
						sx={{
							display: open ? 'flex' : 'none',
							justifyContent: 'center',
							width: '100%',
						}}
					>
						<img
							src="/assets/logo.png"
							width={175}
							loading="lazy"
							alt="yegova TelecommunicationLogo"
						/>
					</Box>
					<IconButton
						onClick={open ? handleDrawerClose : handleDrawerOpen}
						sx={{
							'&:hover': {
								backgroundColor: 'rgba(0, 0, 0, 0.1)',
								color: 'inherit',
							},
						}}
					>
						{open ? (
							theme.direction === 'rtl' ? (
								<ChevronRightIcon />
							) : (
								<ChevronLeftIcon />
							)
						) : theme.direction === 'rtl' ? (
							<ChevronLeftIcon />
						) : (
							<ChevronRightIcon />
						)}
					</IconButton>
				</DrawerHeader>
				<Divider />
				<List>
					{[
						{ text: 'Dashboard', icon: <DashboardIcon />, path: '/' },
						{ text: 'OTT Images', icon: <AddReactionIcon />, path: '/icon' },
					].map((item) => (
						<ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
							<Tooltip title={item.text} placement="right" arrow>
								<ListItemButton
									sx={[
										{
											minHeight: 48,
											px: 2.5,
											backgroundColor:
												location.pathname === item.path
													? '#868686'
													: 'inherit',
											color:
												location.pathname === item.path
													? 'white'
													: 'inherit',
											'&:hover': {
												color: '#fff',
												backgroundColor: '#adadad',
												fill: '#fff',
											},
										},
										open
											? {
													justifyContent: 'initial',
												}
											: {
													justifyContent: 'center',
												},
									]}
									onClick={() => {
										navigate(item.path);
										handleDrawerClose();
									}}
								>
									<ListItemIcon
										sx={[
											{
												minWidth: 0,
												justifyContent: 'center',
												color:
													location.pathname === item.path
														? 'white'
														: 'inherit',
												'&:hover': {
													color: '#fff',
													fill: '#fff',
												},
											},
											open
												? {
														mr: 3,
													}
												: {
														mr: 'auto',
													},
										]}
									>
										{item.icon}
									</ListItemIcon>
									<ListItemText
										primary={item.text}
										sx={[
											open
												? {
														opacity: 1,
														color:
															location.pathname === item.path
																? 'white'
																: 'inherit',
													}
												: {
														opacity: 0,
													},
										]}
									/>
								</ListItemButton>
							</Tooltip>
						</ListItem>
					))}
					{Products.map((productName) => (
						<React.Fragment key={productName}>
							<ListItem disablePadding sx={{ display: 'block' }}>
								<ListItemButton
									onClick={() => navigateToProductList(productName)}
									sx={[
										{
											minHeight: 48,
											px: 2.5,
											backgroundColor: location.pathname.startsWith(
												`/${productName.toLowerCase()}`
											)
												? '#868686'
												: 'inherit',
											color: location.pathname.startsWith(
												`/${productName.toLowerCase()}`
											)
												? 'white'
												: 'inherit',
											'&:hover': {
												color: '#fff',
												backgroundColor: '#adadad',
												fill: '#fff',
											},
										},
										open
											? {
													justifyContent: 'initial',
												}
											: {
													justifyContent: 'center',
												},
									]}
								>
									<ListItemIcon
										sx={[
											{
												minWidth: 0,
												justifyContent: 'center',
												color: location.pathname.startsWith(
													`/${productName.toLowerCase()}`
												)
													? 'white'
													: 'inherit',
												'&:hover': {
													color: '#fff',
													fill: '#fff',
												},
											},
											open
												? {
														mr: 3,
													}
												: {
														mr: 'auto',
													},
										]}
									>
										{productIcons[productName]}
									</ListItemIcon>
									<ListItemText
										primary={productName}
										sx={[
											open
												? {
														opacity: 1,
														color: location.pathname.startsWith(
															`/${productName.toLowerCase()}`
														)
															? 'white'
															: 'inherit',
													}
												: {
														opacity: 0,
													},
										]}
									/>
									{open && (
										<IconButton
											onClick={(e) => {
												e.stopPropagation();
												toggleDropdown(productName);
											}}
											sx={{
												color: location.pathname.startsWith(
													`/${productName.toLowerCase()}`
												)
													? 'white'
													: 'inherit',
												'&:hover': {
													color: '#fff',
												},
											}}
										>
											{dropdownOpen[productName] ? (
												<ExpandLessIcon />
											) : (
												<ExpandMoreIcon />
											)}
										</IconButton>
									)}
								</ListItemButton>
							</ListItem>
							{dropdownOpen[productName] && (
								<List
									component="div"
									disablePadding
									sx={{
										maxHeight: '300px', // Set the maximum height for the dropdown list
										overflowY: 'auto', // Add vertical scrollbar when content exceeds the maximum height
									}}
								>
									{products
										.filter((product) => product.productName === productName)
										.map((product) => (
											<ListItem
												key={product._id}
												disablePadding
												sx={{ display: 'block' }}
											>
												<ListItemButton
													sx={[
														{
															minHeight: 48,
															px: 2.5,
															pl: 4,
															backgroundColor:
																location.pathname ===
																`/${productName.toLowerCase()}/${product._id}`
																	? '#868686'
																	: 'inherit',
															color:
																location.pathname ===
																`/${productName.toLowerCase()}/${product._id}`
																	? 'white'
																	: 'inherit',
															'&:hover': {
																color: '#fff',
																backgroundColor: '#adadad',
																fill: '#fff',
															},
														},
														open
															? {
																	justifyContent: 'initial',
																}
															: {
																	justifyContent: 'center',
																},
													]}
													onClick={() =>
														navigateToProduct(productName, product._id)
													}
												>
													<ListItemText
														primary={product.serviceName}
														sx={[
															open
																? {
																		opacity: 1,
																		color:
																			location.pathname ===
																			`/product/${product._id}`
																				? 'white'
																				: 'inherit',
																	}
																: {
																		opacity: 0,
																	},
														]}
													/>
												</ListItemButton>
											</ListItem>
										))}
								</List>
							)}
						</React.Fragment>
					))}
				</List>
				<Divider />
				<List sx={{ marginTop: 'auto' }}>
					<ListItem disablePadding sx={{ display: 'block' }}>
						<ListItemButton
							onClick={handleLogout}
							sx={[
								{
									minHeight: 48,
									px: 2.5,
									color: '#000',
									'&:hover': {
										color: '#fff',
										backgroundColor: '#adadad',
										fill: '#fff',
									},
								},
								open
									? {
											justifyContent: 'initial',
										}
									: {
											justifyContent: 'center',
										},
							]}
						>
							<ListItemIcon
								sx={[
									{
										minWidth: 0,
										justifyContent: 'center',
										color: 'inherit',
									},
									open
										? {
												mr: 3,
											}
										: {
												mr: 'auto',
											},
								]}
							>
								<Tooltip title="Logout" placement="right">
									<LogoutIcon />
								</Tooltip>
							</ListItemIcon>
							<ListItemText
								primary="Logout"
								sx={[
									open
										? {
												opacity: 1,
											}
										: {
												opacity: 0,
											},
								]}
							/>
						</ListItemButton>
					</ListItem>
				</List>
			</Drawer>
			<Box
				component="main"
				sx={{
					flexGrow: 1,
					p: isXS ? 1 : isSM ? 2 : isMD ? 3 : isLG ? 4 : 5,
					width: isXS
						? 'calc(100% - 65px)'
						: isSM
							? 'calc(100% - 65px)'
							: isMD
								? 'calc(100% - 65px)'
								: isLG
									? 'calc(100% - 65px)'
									: isXL
										? 'calc(100% - 65px)'
										: 'auto',
				}}
			>
				<div>
					<ToastContainer position="top-right" autoClose={3000} />
					<Outlet />
				</div>
			</Box>
		</Box>
	);
}
